import React from "react"
import Layout from "../shared/components/organisms/layout/layout"
import { PackagingDelivery } from "../components/organisms/packaging-delivery/packaging-delivery"
import SEO from "../shared/seo"
import useMediaQuery from "../shared/utils/useMediaQuery"
import { useEffect } from "react"
import { navigate } from "gatsby"

export default function EntregaEmpaques() {
  const isMobile = useMediaQuery()

  useEffect(() => {
    if (process.env.LOCALE !== "es-CO") navigate("/")
  }, [])

  return (
    <Layout mobile={isMobile}>
      <SEO title="Mis Puntos - Entrega de empaques" />
      <PackagingDelivery />
    </Layout>
  )
}
